import { useApi } from '@mainstage/core-plugin-api';
import { useQuery } from '@tanstack/react-query';
import { identityApiRef } from '@mainstage/core-plugin-api';
import { SYSTEM_PROTOTYPES_QUERY_KEY } from './constants';
import { systemPrototypeApiRef } from '@agilelab/plugin-wb-system-prototype-common';

export const useSystemPrototypes = (taxonomyRef?: string) => {
  const identityApi = useApi(identityApiRef);
  const systemPrototypeApi = useApi(systemPrototypeApiRef);

  return useQuery({
    queryKey: [SYSTEM_PROTOTYPES_QUERY_KEY, taxonomyRef],
    queryFn: async () => {
      const credentials = await identityApi.getCredentials();
      if (!credentials.token) {
        throw new Error('No token available');
      }
      const typedCredentials = { token: credentials.token };

      const systemPrototypes = await systemPrototypeApi.getSystemPrototypes(
        typedCredentials,
        taxonomyRef,
      );
      return systemPrototypes;
    },
  });
};
